import React, { FC, useEffect, useState } from 'react';
import Styles from './LineTableV3Refined.module.scss';
import { CMSStoryblokServiceV2 } from '@sunrise-upc/ajax-lib';
import { LineTableBasicPropConfig } from '../../services/LineTableBasicPropConfig';
import { fetchOfferingDataLineTableV2, getVocherPromotion } from '../../services/LineTableService';
import { getElementMaximumHeight, setLocalStoreWithExpiry, viewport } from '../../utils/utils';
import { fetchProductIds } from './ProductV3';
import CarouselComponent from '../sharedCarousel/CarouselComponent';
import BundleProductsV3 from './BundleProductsV3';
import { ProductContainerSchema, ProductRequestBase } from './lineTable.types';
import { trackEligibleItem } from '../../models/Analytics/items';
import { LINETABLE } from '../../Analytics/AnalyticsConstants';
import Cookies from 'js-cookie';
import { VCTYPE, VOUCHER } from '../../utils/constants';

const ProductContainerV3: FC<ProductContainerSchema> = ({
  content,
  metadata,
  activeIndex,
  lineCheckCallBack,
  sbStaticConstants,
  address,
  eligibleBundle,
  setGenericErrorModalDetails,
  loginSuccess,
  ratePlansToRemove,
  isProdEnv
}): any => {
  const activelocaleId: string | undefined = metadata?.lang;
  const [offeringData, setOfferingData] = useState<any>();
  const uniqueId: keyof typeof offeringData = content?._uid;
  const [productList, setProductList] = useState<any[]>([]);
  const matchingProductList: any = [];
  const storyIds = new Map();
  const sbParams = {
    language: activelocaleId,
    type: 'B2C'
  };
  const productParentSlug: any = {};
  const viewPort = viewport();
  const sbEndpoint = LineTableBasicPropConfig?.getInstance()?.getSBUrl();
  const offerEndpoint = LineTableBasicPropConfig?.getInstance()?.getBaseUrl();
  const summaryUrl = content?.lineTableContent?.summaryPageUri?.cached_url;
  const [isMobileFlow, setIsMobileFlow] = useState<boolean>(false);
  let AuthData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
  AuthData = AuthData && JSON.parse(AuthData);

  /**
   * fetching offer response
   */
  const fetchOfferData = () => {
    const ProductIds: ProductRequestBase[] = [];
    // for getting product offer api call request and promo id list
    //existingCustomerBenefit without login
    const existingCustomer=content?.lineTableContent?.enableExistingCustomer;
    const subscriptionType=content?.lineTableContent?.subscriptionType;
    const enableReturnPromo=content?.isReturnPromo;
    fetchProductIds(ProductIds, content?.productList || []);
    if ((content?.tabIndex === content?.activeIndex && !offeringData?.[uniqueId]) ||(content?.tabIndex === content?.activeIndex && loginSuccess)) {
      if (content?.dynamicProductOffer) {
        try {
          fetchOfferingDataLineTableV2(ProductIds, content?._uid, offerEndpoint,existingCustomer,subscriptionType,enableReturnPromo)
            ?.then((resp: any) => {
              setOfferingData(resp);
              setGenericErrorModalDetails({ showPopup: false });
            })
            .catch((error: any) => {
              // eslint-disable-next-line no-console
              console.log('error--->', error);
              setGenericErrorModalDetails({
                showPopup: true,
                content: content?.lineTableContent?.telesalesBlok?.[0]
              });
            });
        } catch (err: any) {
          // eslint-disable-next-line no-console
          console.log('error--->', err);
          setGenericErrorModalDetails({
            showPopup: true,
            content: content?.lineTableContent?.telesalesBlok?.[0]
          });
        }
      }
    }
  };

  /**
   * triggering offer api based for the selected tab
   */
  useEffect(() => {
    if (activeIndex == content?.tabIndex || !activeIndex) {
      fetchOfferData();
    }
  }, [content?.activeIndex]);
  /**
   * stories call
   */
  useEffect(() => {
    (content?.productList || []).forEach((key: any) => {
      if (!storyIds.get(key?.products?.product_story_uuid)) {
        storyIds.set(key?.products?.product_story_uuid, {
          k: 0,
          prod_id: key?.products.product_id,
          showPromotion: key?.products?.dontShowPromotion
        });
      }
      if (!storyIds.get(key?.products?.home_promo_story_uuid)) {
        storyIds.set(key?.products?.home_promo_story_uuid, {
          k: 0
        });
      }
      if (
        (content?.pageType === '4P' || content?.pageType === 'MOBILE') &&
        key?.products?.mob_promo_story_uuid &&
        key?.products?.mob_promo_story_uuid !== '' &&
        !storyIds?.has(key?.products?.mob_promo_story_uuid)
      ) {
        storyIds?.set(key?.products?.mob_promo_story_uuid, {
          k: 0
        });
      }
      matchingProductList.push(key);
      // }
    });

    if (content?.pageType === 'MOBILE') {
      setIsMobileFlow(true);
    }

      if (storyIds.size > 0) {
      let uuids = '';
      for (const [key, value] of storyIds.entries()) {
        if (value.k == 0) {
          uuids = uuids + key + ',';
          value.k = 1;
        }
      }

      const urllll = sbEndpoint + `rest/cms/stories/?by_uuids=${uuids}`;
      CMSStoryblokServiceV2.get(urllll, sbParams)
        .then((data) => {
          data?.data?.stories?.map((story: any) => {
            const stroyObject = storyIds.get(story?.uuid);
            stroyObject.stroy = story;
          });
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        })
        .finally(() => {
          const anotherList: any = [];

          if (matchingProductList.length > 0) {
            if (content?.pageType !== 'MOBILE') {
              const subStoryIds = new Map();
              matchingProductList?.map((item: any) => {
                const prod = storyIds.get(item?.products?.product_story_uuid)?.stroy;
                if (prod?.content && prod?.content?.body && prod?.content?.body[0]) {
                  const configuredProducts = prod?.content?.body[0]?.products;
                  configuredProducts?.map((key: any) => {
                    if (!subStoryIds.get(key?.listProduct)) {
                      subStoryIds.set(key?.listProduct, {
                        k: 0,
                        prod_id: key?.listProduct,
                        order: key?.order
                      });
                    }
                  });
                }
              });

              if (subStoryIds.size > 0) {
                let buuids = '';
                for (const [key, value] of subStoryIds.entries()) {
                  if (value.k == 0) {
                    buuids = buuids + key + ',';
                    value.k = 1;
                  }
                }
                const urllll2 = sbEndpoint + `rest/cms/stories/?by_uuids=${buuids}`;
                CMSStoryblokServiceV2.get(urllll2, sbParams)
                  .then((data) => {
                    data.data.stories?.map((story: any) => {
                      const stroyObject = subStoryIds.get(story.uuid);
                      stroyObject.storyBody = story?.content?.body?.[0] || null;
                      stroyObject.storyBody.default_full_slug = story?.default_full_slug;
                      stroyObject.storyBody.slug = story?.slug;
                    });
                  })
                  .catch((err) => {
                    // eslint-disable-next-line no-console
                    console.log(err);
                  })
                  .finally(() => {
                    matchingProductList?.map((item: any) => {
                      const prod = storyIds.get(item?.products?.product_story_uuid)?.stroy;
                      if (prod?.content && prod?.content?.body && prod?.content?.body[0]) {
                        const prodBody = prod?.content?.body[0];
                        const anotherProdList: any = [];
                        const configuredProducts = prodBody?.products;
                        configuredProducts?.map((key: any) => {
                          const prodTempData = subStoryIds.get(key?.listProduct)?.storyBody;
                          anotherProdList.push(
                            Object.assign({}, key, {
                              cProd: prodTempData
                            })
                          );

                          if (prodTempData) {
                            const poTypeTemp = prodTempData?.poType
                              ? prodTempData?.poType
                              : prodTempData?.subGroup;

                            if (!productParentSlug[poTypeTemp]) {
                              let path2Replace = prodTempData?.slug;
                              if (
                                poTypeTemp === 'TV' &&
                                (prodTempData?.tvGroup === 'NETFLIX' ||
                                  prodTempData?.tvGroup === 'PREMIUM' ||
                                  prodTempData?.tvGroup === 'SPORTS')
                              ) {
                                path2Replace = 'entertainment/' + path2Replace;
                              } else if (
                                poTypeTemp === 'TV' &&
                                (prodTempData?.tvGroup === 'TVBOX' ||
                                  prodTempData?.tvGroup === 'TVAPP')
                              ) {
                                path2Replace = 'tvboxorapp/' + path2Replace;
                              }
                              const temp = prodTempData?.default_full_slug.replace(
                                path2Replace,
                                ''
                              );
                              productParentSlug[poTypeTemp] = {
                                slug: temp
                              };
                            }
                          }
                        });

                        prodBody.products = anotherProdList;
                      }
                      let tempPromotionObject = Object.assign(
                        {},
                        storyIds.get(item?.products?.home_promo_story_uuid)
                      );
                      (tempPromotionObject.prom = item?.products?.home_parent_promo_id),
                        (tempPromotionObject.isDefault = item?.products?.home_promo_default);
                      let tempStoryObject = Object.assign({}, item, {
                        productStroyObj: prod,
                        promStroyObj: tempPromotionObject,
                        showPromotion: item?.dontShowPromotion
                      });
                      anotherList.push(tempStoryObject);
                    });
                    try {
                      localStorage.setItem('slugDetails', JSON.stringify(productParentSlug));
                    } catch {
                      //
                    }
                    setProductList(anotherList);
                  });
              }
            } else {
              if (matchingProductList?.length > 0) {
                matchingProductList?.map((item: any, index: number) => {
                  let tempPromotionObject;
                  if (content?.pageType === 'MOBILE') {
                    // would run for mobile and prepaid pages
                    tempPromotionObject = Object?.assign(
                      {},
                      storyIds?.get(item?.products?.mob_promo_story_uuid)
                    );
                    (tempPromotionObject.prom = item?.products?.mob_parent_promo_id),
                      (tempPromotionObject.isDefault = item?.products?.mob_promo_default);
                  }
                  const tempStoryObject = Object?.assign({}, item, {
                    productStroyObj: storyIds?.get(item?.products?.product_story_uuid),
                    promStroyObj: tempPromotionObject
                  });
                  if (index == 0) {
                    // for getting the parent slug.
                    const stObject = tempStoryObject?.productStroyObj?.stroy;
                    if (stObject) {
                      const sObjectContent = stObject?.content;
                      const poTypeTemp = sObjectContent?.body[0]?.poType
                        ? sObjectContent?.body[0]?.poType
                        : sObjectContent?.body[0]?.subGroup;
                      if (!productParentSlug[poTypeTemp]) {
                        const temp = stObject?.default_full_slug?.replace(stObject?.slug, '');
                        productParentSlug[poTypeTemp] = {
                          slug: temp
                        };
                      }
                    }
                  }
                  /* for getting the global display config at product table */
                  tempStoryObject.displayConfig = content?.displayConfig ?? [];
                  anotherList?.push(tempStoryObject);
                });
                setProductList(anotherList);
              }
            }
          }
        });
    }
  }, [activelocaleId]);

  useEffect(() => {
    const queryParams = window && new URLSearchParams(window?.location.search);
    const voucher: string | null = queryParams?.get(VOUCHER);
    if (voucher && productList?.length > 0) {
      try {
        getVocherPromotion(productList?.[0]?.products?.product_id, voucher).then((res: any) => {
          res && setLocalStoreWithExpiry(VCTYPE, { voucher: voucher, voucherType: 'qoqa' });
        });
      } catch (err: any) {
        // eslint-disable-next-line no-console
        console.log('voucher qoqa Error');
      }
    }

    setTimeout(() => {
      findHeight();
    }, 100);
    window?.addEventListener('resize', findHeight);
    window?.addEventListener('load', findHeight);
    return () => {
      window.removeEventListener('resize', findHeight);
      window.removeEventListener('load', findHeight);
    };
  }, [productList]);

  useEffect(() => {
    if (ratePlansToRemove && ratePlansToRemove?.length > 0) {
      const filteredProductList = productList?.filter(
        (prod: any) => !ratePlansToRemove?.includes(prod?.products?.product_id)
      );
      setProductList(filteredProductList);
    }
  }, [ratePlansToRemove])

  const findHeight = () => {
    getElementMaximumHeight(
      'productCardV3' + `${content?.activeIndex}`,
      content?.productList?.length
    );
  };

  useEffect(() => {
    if (offeringData && Object.keys(offeringData)?.length > 0) {
      trackEligibleItem('view', offeringData[uniqueId], '', LINETABLE);
    }
  }, [offeringData]);

  useEffect(() => {
    if (
      offeringData &&
      Object.keys(offeringData)?.length > 0 &&
      !isMobileFlow &&
      eligibleBundle?.eligibleBundle
    ) {
      trackEligibleItem(
        'available',
        offeringData[uniqueId],
        '',
        LINETABLE,
        eligibleBundle?.eligibleBundle
      );
    }
  }, [offeringData, address]);

  useEffect(() => {
    if (AuthData?.siteId && loginSuccess) {
      fetchOfferData();
    }
  }, [loginSuccess]);
  return (
    <div>
      <div className={Styles['titlecontainer']}>
        {content?.title && <div className={Styles['title']}>{content?.title}</div>}
        {content?.subTitle && <div className={Styles['description']}>{content?.subTitle}</div>}
      </div>
      <div className={`linetableV3`}>
        {viewPort && (
          <CarouselComponent carouselIndex={content?.activeIndex} key={activeIndex} arrow={content?.lineTableContent?.enableMobileArrows}>
            {(
              (productList?.length && productList) ||
              new Array(productList?.length || 3).fill(1)
            ).map((key, index) => {
              return (
                <div
                  key={index}
                  id={`productCardV3${content?.activeIndex}`}
                  style={{ textAlign: 'center'}}
                 
                >
                  <BundleProductsV3
                    content={key}
                    updatedContent={content}
                    key={index}
                    indexKey={index}
                    lineTableContent={content?.lineTableContent}
                    metadata={metadata}
                    productSection={index}
                    cards={content?.productList?.length}
                    tabIndex={content?.tabIndex}
                    offeringData={offeringData}
                    uniqueId={uniqueId}
                    lineCheckCallBack={lineCheckCallBack}
                    sbStaticConstants={sbStaticConstants}
                    address={address}
                    eligibleBundle={eligibleBundle}
                    summaryUrl={summaryUrl}
                    isMobileFlow={isMobileFlow}
                    isProdEnv={isProdEnv}
                  />
                </div>
              );
            })}
          </CarouselComponent>
        )}
      </div>
    </div>
  );
};
export default ProductContainerV3;
